import { useContext, useEffect } from "react"
import {
  IExtendedMessage,
  setNotifications,
} from "../../app/slices/notificationSlice"
import { store } from "../../app/store"
import AuthContext from "../../providers/AuthProvider"
import { GetMessagesForCustomerRq } from "@smartx/mikro-vt-client-api"
import { RequestHeader } from "../../utils/utils"
import { messagesApi } from "../../api/apiClient"
import CaseAndOfferLoader from "../Cases/CaseAndOfferLoader"

const rq: GetMessagesForCustomerRq = {
  header: new RequestHeader(),
}

const Dashboard = () => {
  const authContext = useContext(AuthContext)

  useEffect(() => {
    authContext.refresh()

    messagesApi.getMessagesForCustomer(rq).then((res) => {
      const data = res.data.messages.map(
        (message) =>
          ({
            ...message,
            clicked: false,
            readOnInit: message.read,
          }) as IExtendedMessage,
      )

      store.dispatch(setNotifications(data ?? []))
    })
  }, [authContext])

  return <CaseAndOfferLoader />
}

export default Dashboard
